//When clicking registration this is the text
import { Typography } from "@mui/material";
export const HOW_TO_REGISTER =
  "Registration opens August 4th and is done on the CVENT website. " + 
    "It is now open at the link below! Please follow the instructions below to secure your spot for Frosh. " +
      "If you require any financial assistance to participate in Frosh, we have bursaries available! Please consult our FAQ Registration Page for more details. "+
        "If you have any further questions, also consult our FAQ page and then feel free to contact us on any platform linked at the bottom of the page.";

export const STEPS_TO_TAKE = [
  <Typography variant="p">
    <strong>Step 1:</strong> Go to the CVENT Engineering Frosh website linked below. <br></br>
    <div style={{ padding: "20px 25px 1em 69px"}}> 
    <Typography variant="p">
      Click the <b>Register Now</b> button in the top right corner.
      </Typography>
    </div>
    <strong>Step 2:</strong> Fill out your personal information. <br></br>
    <div style={{ padding: "20px 25px 1em 69px"}}> 
    <Typography variant="p">
      Make sure you use your full name and the same email address you applied to McGill with.
      </Typography>
    </div>
    <strong>Step 3:</strong> Fill out the rest of the registration form and pay for your ticket. <br></br>  
    <div style={{ padding: "20px 25px 1em 69px"}}> 
    <Typography variant="p">
      You will receive a confirmation email once the online registration and payment are complete!
      </Typography>
    </div> 
    <strong>Step 4:</strong> Complete the MANDATORY trainings. There are <strong>2</strong> in total: the Sexual Violence
    training called <q>It Takes All of Us</q> and the <q>Frosh 101</q> training all on MyCourses. More information on trainings will appear on our Instagram and Facebook in the first couple weeks of August. <br></br><br></br>
    <strong>Step 5:</strong> Complete your registration and pick up your Frosh merch at Registration tent (DO NOT FORGET YOUR MCGILL ID!). Registration tent is open from August 22nd - August 26th between 11am - 4pm EST. <br></br>  
  </Typography>,
  
];
